import { library } from '@fortawesome/fontawesome-svg-core';
import {
    faCaretDown,
    faCaretUp,
    faChevronLeft,
    faChevronRight,
    faCircle,
    faCalendarAlt,
    faSignOut,
    faExternalLink,
    faUser,
    faPlayCircle,
    faListUl,
    faPrint,
    faFileAlt,
    faArrowAltToBottom,
    faTimes,
    faTimesCircle,
    faSlidersH,
    faSearch,
    faVolumeUp
} from '@fortawesome/pro-solid-svg-icons';
import {
    faClock
} from '@fortawesome/pro-regular-svg-icons';
import {
    faAngleRight
} from '@fortawesome/pro-light-svg-icons';

const initializeLibrary = () => {
    library.add(faAngleRight, faCaretDown, faCaretUp, faChevronLeft, faChevronRight, faCircle, faCalendarAlt, faSignOut,
        faExternalLink, faUser, faPlayCircle, faListUl, faPrint, faFileAlt, faArrowAltToBottom, faTimes, faTimesCircle,
        faSlidersH, faClock, faSearch, faVolumeUp);
};

export {
    initializeLibrary
};
